<template>
    <div class="meal-item">
        <a href="#" data-target="#patient-meal-detail" data-toggle="modal" @click="showMealDetail()">
            <figure class="meal-image">
                <img :src="meal.resource" v-if="meal.resource" />
                <svg-icon icon="icon-no-meals" v-else />

                <span v-for="(tag, index) in meal.meal_tags" :key="index" class="meal-tag" :style="'top: '+getPosition(tag.position_y)+'%; left: '+getPosition(tag.position_x)+'%'">
                    <span>{{ tag.name }}</span>
                </span>
            </figure>
        </a>

        <div
            :class="[
                'meal-content',
                { 'comment-editing': isCommentEditing, 'coach-edit': isCommentEditable }
            ]"
            @click="showForm()"
        >
            <div v-if="meal.notes" class="meal-note">{{ meal.notes }}</div>

            <div class="meal-footer">
                <time>{{ meal.time.substr(0, 5) }}</time>

                <span v-if="!hasComment && !feedback" class="meal-seen">
                    <figure>
                        <span class="material-icons">check_circle</span>
                    </figure>
                    <span>{{ __('Seen') }}</span>
                </span>
            </div>

            <div class="meal-comment-wrapper">
                <div v-if="feedback" class="meal-comment meal-feedback">
                    <p v-html="__(feedback)"></p>
                    <figure>
                        <svg-icon icon="vitadio-logo"></svg-icon>                                                                
                    </figure>
                </div>
                
                <div v-else-if="hasComment" :class="['meal-comment']">
                    <p>{{ comment }}</p>
                    <user-avatar :user-info="coach"></user-avatar>
                    <figure class="meal-edit">
                        <span class="material-icons">edit</span>
                    </figure>
                </div>

                <form v-if="isCommentEditable && isCommentEditing || isCommentEditable && !hasComment" :id="'meal-comment-' + meal.id" class="meal-comment-form" action="" method="POST">
                    <div class="input-wrapper form-input-textarea">
                        <label ref="label" :class="['is-float-label', {'float-label-active': comment !== null && comment !== ''}]" for="comment">{{ __('Comment') }}</label>
                        <textarea
                            id="comment"
                            name="comment"
                            ref="textarea"
                            v-model="comment"
                            v-on:keyup.enter="submit()"
                            v-on:keydown.enter.prevent
                            @click="isCommentEditing = true"
                            :placeholder="__('Comment')"
                            class="basic-border"
                        ></textarea>
                    </div>

                    <emoji-icon :sync-input="'#meal-comment-' + meal.id + ' textarea'" />
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            meal: {
                type: Object,
                required: true
            },
            coach: {
                type: Object,
                required: false
            },
            editable: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                comment: this.meal.comment,
                isCommentEditing: false,
                feedback: this.meal.feedback ? this.meal.feedback.message : null,
                hasComment: this.meal.comment ? true : false
            }
        },
        watch: {
            comment(comment) {
                const textarea = this.$refs.textarea

                if (comment === '') {
                    textarea.style.height = '28px'
                } else {
                    textarea.style.height = textarea.scrollHeight + 'px'
                    textarea.style.overflow = 'hidden'
                }
            }
        },
        computed: {
            isCommentEditable() {
                if(!this.feedback && this.editable) {
                    return true
                }

                return false
            }
        },
        methods: {
            submit() {
                var form = {
                    comment: this.comment
                }

                axios
                    .post('/meal/' + this.meal.id + '/comment', form)
                    .then(() => {
                        console.log('Submission was successful.')
                        this.hasComment = true
                        this.isCommentEditing = false
                    })
                    .catch((e) => {
                        console.log('An error occurred.')
                    })
            },
            showForm() {
                if (this.isCommentEditable === false) return false

                this.isCommentEditing = true

                setTimeout(() => {
                    const textarea = this.$refs.textarea

                    textarea.style.height = textarea.scrollHeight + 'px'
                }, 100)
            },
            showMealDetail() {
                $('#patient-meal-detail').trigger('meal', this.meal)

                return false
            },
            getPosition(position) {
                if(position <= 1) {
                    return position * 100;
                } else if(position <= 100) {
                    return parseInt(position);
                }
            }
        }
    }
</script>
